import { InvoiceRepository } from "../../domain/repositories/InvoiceRepository";
import {
  InvoicesResultEntity,
  ZohoInvoiceDetailsEntity,
} from "../../domain/entities/InvoiceListItemEntity";
import {
  getInvoicesForCustomer,
  getZohoInvoiceDetails,
} from "../api/getCustomerInvoicesApi";
import { InvoiceMapper } from "../mappers/InvoiceMapper";

export class InvoiceRepositoryImpl implements InvoiceRepository {
  async getInvoicesForCustomer(
    customerZohoId: string,
    limit?: number,
    offset?: number,
    search?: string
  ): Promise<InvoicesResultEntity> {
    const dto = await getInvoicesForCustomer(
      customerZohoId,
      limit,
      offset,
      search
    );
    return InvoiceMapper.toResultEntity(dto);
  }

  async getZohoInvoiceDetails(
    zohoInvoiceId: string
  ): Promise<ZohoInvoiceDetailsEntity> {
    const dto = await getZohoInvoiceDetails(zohoInvoiceId);
    // Map DTO to entity (they have the same structure, so we can return directly)
    return dto.data;
  }
}
